import React, { useEffect, useState, useContext, useRef } from 'react';
import { Carousel } from 'react-responsive-carousel';

import { withKnobs, boolean, number } from '@storybook/addon-knobs';

import { ContextNotificacoes } from '../../services/notificacoes';
import { ContextGetData } from '../../services/getData';

import Modal from '../ImgHomeExpand';

import './styles.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const tooglesGroupId = 'Toggles';
const valuesGroupId = 'Values';

const getConfigurableProps = () => ({
  showArrows: boolean('showArrows', true, tooglesGroupId),
  showStatus: boolean('showStatus', false, tooglesGroupId),
  showIndicators: boolean('showIndicators', true, tooglesGroupId),
  infiniteLoop: boolean('infiniteLoop', false, tooglesGroupId),
  showThumbs: boolean('showThumbs', true, tooglesGroupId),
  useKeyboardArrows: boolean('useKeyboardArrows', true, tooglesGroupId),
  autoPlay: boolean('autoPlay', false, tooglesGroupId),
  stopOnHover: boolean('stopOnHover', false, tooglesGroupId),
  swipeable: boolean('swipeable', true, tooglesGroupId),
  dynamicHeight: boolean('dynamicHeight', true, tooglesGroupId),
  emulateTouch: boolean('emulateTouch', true, tooglesGroupId),
  thumbWidth: number('thumbWidth', 220, {}, valuesGroupId),
  selectedItem: number('selectedItem', 0, {}, valuesGroupId),
  interval: number('interval', 3000, {}, valuesGroupId),
  transitionTime: number('transitionTime', 500, {}, valuesGroupId),
  swipeScrollTolerance: number('swipeScrollTolerance', 5, {}, valuesGroupId),
});

export default {
  title: '01 - Basic',
  decorators: [withKnobs],
  component: Carousel,
};

export const Carrossel = () => {
  const { getFotoUrlS3 } = useContext(ContextNotificacoes);

  const {
    imagensEmpreendimento,
    dataUltimaAtualizacaoFotos,
    setImagensEmpreendimento,
    dataFotoTirada,
    updateImagesUrl,
  } = useContext(ContextGetData);

  const [fotoAtual, setFotoAtual] = useState(1);

  const [expandImg, setExpandImg] = useState(false);

  const [imgSrc, setImgSrc] = useState('');

  const ref = useRef([]);

  useEffect(() => {
    loadSubtitles();
  }, [imagensEmpreendimento]);

  useEffect(() => {
    loadDataAtualizacaoFotos();
    // faz o load de novas fotos a cada 5 fotos
    if (fotoAtual % 5 === 0) {
      (async function () {
        await updateImagesUrl(fotoAtual + 5, imagensEmpreendimento);
      })();
    }
  }, [fotoAtual]);

  const ultimaDataAtualizacaoFotos = dataUltimaAtualizacaoFotos?.split(' ')[0];

  async function onErrorImageS3(index) {
    const image = imagensEmpreendimento[index];
    const idAws = image?.idAws;

    if (idAws) {
      try {
        const src = await getFotoUrlS3(idAws);

        const newArrayImagens = [...imagensEmpreendimento];
        newArrayImagens[index].Uri = src;
        setImagensEmpreendimento(newArrayImagens);

        return src;
      } catch (e) {
        console.error('getFotoURLS3', e);
      }
    }
  }

  function addOnErrorToRefs() {
    ref.current.forEach((element, index) => {
      //adicionando listener apenas nos elementos que não estiverem vazios(são os que tem idAws)
      if (element) {
        element.addEventListener('error', () => onErrorImageS3(index));
      }
    });
  }

  function imageHasIdAws(idAws, el, index) {
    if (idAws) {
      ref.current[index] = el;
    }
  }

  const createCarouselItemImage = (item, index) => (
    <div
      key={item?.id}
      id={item?.id}
      onClick={() => {
        setImgSrc(item?.Uri);
        setExpandImg(!expandImg);
      }}
    >
      <img
        loading='lazy'
        src={item?.Uri}
        ref={(el) => imageHasIdAws(item?.idAws, el, index)}
        id={item?.id}
      />
      <div className='boxLegendaFoto'>
        <span className='legendaFotoGrande'>
          {trataNomeLegenda(item?.nome)}
        </span>
      </div>

      <p>{ultimaDataAtualizacaoFotos}</p>
    </div>
  );

  function trataNomeLegenda(nome) {
    return nome.replace('.jpg', '').replace('.jpeg', '').replace('.png', '');
  }

  const loadSubtitles = () => {
    let itemThumb = Array.from(document.getElementsByClassName('thumb'));

    for (let i = 0; i < itemThumb.length; i++) {
      itemThumb[i].addEventListener('click', () => {});

      itemThumb[i]?.querySelector('small')?.remove();

      let p = document.createElement('small');

      p.innerHTML = trataNomeLegenda(imagensEmpreendimento[i].nome);

      itemThumb[i]?.appendChild(p);
    }
  };

  const loadDataAtualizacaoFotos = () => {
    let c = Array.from(document.getElementsByClassName('carousel-root'));

    let divData = document.createElement('div');

    let data = Array.from(
      document.getElementsByClassName('data-atualizacao-fotos')
    );

    if (data.length > 0)
      data[0].innerHTML = `
         <span>Data de atualização da foto: ${ultimaDataAtualizacaoFotos}</span>
         ${
           dataFotoTirada &&
           `<span>Data da última foto tirada: ${dataFotoTirada
             ?.split('T')[0]
             .split('-')
             .reverse()
             .join('/')}</span>`
         }
         <span>Foto(s) ${fotoAtual < 10 ? '0' + fotoAtual : fotoAtual}/${
        imagensEmpreendimento.length
      }</span>
        `;
    else {
      divData.className = 'data-atualizacao-fotos';
      divData.innerHTML = `<span>Data de atualização da foto: ${ultimaDataAtualizacaoFotos}</span>
      <span>Foto(s) ${fotoAtual < 10 ? '0' + fotoAtual : fotoAtual}/${
        imagensEmpreendimento.length
      }</span>
     `;

      c[0]?.appendChild(divData);
    }
  };

  const baseChildren = (
    <div>
      {imagensEmpreendimento.map((i, index) =>
        createCarouselItemImage(i, index)
      )}
    </div>
  );

  useEffect(() => {
    addOnErrorToRefs();
  }, [ref]);

  return (
    <>
      {expandImg && (
        <Modal imgSrc={imgSrc} setExpandImg={setExpandImg} onError={''} />
      )}

      <Carousel
        {...getConfigurableProps()}
        onChange={(index, item) => {
          setImgSrc(item?.props?.children[0]?.props?.src);
          setFotoAtual(index + 1);
        }}
      >
        {baseChildren.props.children}
      </Carousel>
    </>
  );
};
